import { Component, OnInit, Inject } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {AuthenticationService} from '../../../services/authentication.service';
import {first} from 'rxjs/operators';
import {Router} from '@angular/router';
import {MasterPageComponent} from '../../masterpage.component';
import {GenericModalService} from '../../../services/generic-modal.service';
import {ChangePasswordComponent} from '../../../Views/Account/change-password/change-password.component';

@Component({
  selector: 'app-header-menu',
  templateUrl: './header-menu.component.html',
  styleUrls: ['./header-menu.component.css']
})

export class HeaderMenuComponent implements OnInit {

  // menuItems$: Observable<MenuItem[]>;

  // isExpanded = false;

  isLoggedIn$: Observable<boolean>;

  username = localStorage.getItem('userLogon');

  /*collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }*/

  changeBrand() {
    if (document.body.classList.contains('sidebar-collapse')) {
      document.getElementById('horizontal-brand').hidden = false;
      document.getElementById('rounded-brand').hidden = true;
    } else {
      document.getElementById('horizontal-brand').hidden = true;
      document.getElementById('rounded-brand').hidden = false;
      this.master.closeSideBarDropDown();
    }
  }

  constructor(private authenticationService: AuthenticationService, private router: Router, private master: MasterPageComponent,
              private modalService: GenericModalService) {

  }

  ngOnInit() {
    this.isLoggedIn$ = this.authenticationService.isLoggedIn;
    // this.menuItems$ = this.authenticationService.getMenus;

  }

  onLogout() {
    this.authenticationService.logout()
      .subscribe(
        (data) => {
          this.router.navigate(['/login']);
        },
        (err) => console.log(err)
      );
  }

  openChangePassModal() {
    const comp: any = ChangePasswordComponent;
    this.modalService.showObjModal(comp, 'Alterar senha', '', 'modal-md');
  }
}
